import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    token: sessionStorage.getItem('appId') ? sessionStorage.getItem('appId') : '',
    status: '1',
  },
  mutations: {
    SetToken(state, token) {
      state.token = token;
    },
    SetStatus(state, status) {
      state.status = status;
    }
  },
  getters: {
    GetToken(state) {
      return state.token;
    },
    GetStatus(state) {
      return state.status
    }
  }
})
export default store;
